export default __webpack_public_path__ + "static/media/text0INFO.04e4cfcd.glb";